<script>
  import { Textfield } from "../../components";

  import Select, { Option } from "@smui/select";
  import HelperText from "@smui/select/helper-text/index";
  import Checkbox from '@smui/checkbox';
  import FormField from '@smui/form-field';

  export let groupOptions = null;
  export let flagOptions = null;
  export let data = null;
  export let errors = {};
  console.log("Data: ", data);
  console.log("errors: ", errors);
</script>
<Textfield fullwidth bind:value={data.name} label="Name" error={errors.name} />

<Textfield
  textarea
  fullwidth
  bind:value={data.description}
  label="Description"
  error={errors.description} />

<div class="flex">
<Textfield
  type="number"
  class="number"
  bind:value={data.amount}
  label="Amount"
  error={errors.amount} />

<Select bind:value={data.status} label="Active">
  <Option value="active">yes</Option>
  <Option value="suspended">no</Option>
</Select>
<HelperText validationMsg>{errors.status}</HelperText>

{#if groupOptions}
<Select bind:value={data.item_group} label="Group">
  {#each groupOptions as group}
    <Option value={group}>{group}</Option>
  {/each}
</Select>
<HelperText validationMsg>{errors.item_group}</HelperText>
{/if}
</div>
{#if flagOptions}
<div>
  {#each flagOptions as flag}
    <FormField>
        <Checkbox bind:group={data.flags} value={flag}/>
        <span slot="label">{flag}</span>
      </FormField>
  {/each}
</div>
<HelperText validationMsg>{errors.flags}</HelperText>
{/if}



